import { connect } from 'react-redux'
import { setSignUpModalIsOpen } from 'redux/actions'
import QaResultsItemQuestion from 'components/search/results-item/QaResultsItemQuestion'

const mapStateToProps = (state) => ({
  flavour: state.layout.flavour,
  isLogged: state.user.isLogged
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(QaResultsItemQuestion)
